module.exports = __webpack_public_path__ + "static/img/发布公告.38df99f5.png";